import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useCreateConnection } from 'queries/useConnection';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type AddConnectionModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

function AddConnectionModal({ isOpen, onClose }: AddConnectionModalProps) {
  const [displayName, setDisplayName] = useState<string>('');
  const { t } = useTranslation();
  const [createError, setCreateError] = useState<string | null>(null);
  const { mutate: createConnection, isPending: isCreating } = useCreateConnection();
  const createNewConnection = async () => {
    if (!displayName?.trim()) {
      setCreateError(t('common.fieldRequired', { field: t('connection.name') }));
      return;
    }
    setCreateError(null);
    createConnection(
      { displayName: displayName.trim() },
      {
        onSuccess: (res) => {
          if (res.consent_link) {
            window.location.href = res.consent_link;
            onClose();
            setDisplayName('');
          }
        },
      }
    );
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setDisplayName('');
        setCreateError(null);
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('connection.createConnection')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <Input
              onChange={(e) => {
                setDisplayName(e.target.value);
                setCreateError(null);
              }}
              placeholder={t('connection.enterDisplayName')}
              value={displayName}
            />
            {!!createError && <Text color='red.500'>{createError}</Text>}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='blue' isLoading={isCreating} onClick={createNewConnection}>
            {t('common.create')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default AddConnectionModal;
